import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const OLDACCOUNT_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('sapCode', 'Entity.OldAccount.SapCode')
    .required()
    .build(),
  FieldBuilder.text('description', 'Entity.OldAccount.Description')
    .required()
    .build(),
];

export const OLDACCOUNT_CONFIG = {
  entityName: 'OldAccount',
  localizationKey: 'Controlling::Entity.OldAccount',
  fields: OLDACCOUNT_FIELDS,
  permission: 'ControllingSap.OldAccounts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
